import React from "react";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import config from "../config/config";
import { CodeContext } from "../component/Context/CodeContext";
import { GameDataContext } from "../component/Context/GameDataContext";
const useScoreSubmit = () => {
  const [response_data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { dispatch, state } = useContext(CodeContext);
  const { gameDispatch } = useContext(GameDataContext);

  const callApi = async (id, body, practice) => {
    gameDispatch({ type: "LOADING", data: true });
    // if (practice === false) {
    console.log("id", id, state);
    if (id === undefined || id === -1 || id === "-1") {
      id = state.gameId;
    }
    if (id === undefined) {
      setLoading(false);
      gameDispatch({ type: "LOADING", data: false });
      return;
    }
    axios
      .post(`${config.apiURL}challenge/score/${id}`, body)
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
        gameDispatch({ type: "LOADING", data: false });
      });
  };
  // else {
  //   setLoading(false);
  // }
  // };

  return { response_data, loading, error, callApi };
};
export default useScoreSubmit;
